import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/tmp/26d35be0/src/layouts/work.js"
import TextCol from '../../components/TextCol'

export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={props}
             components={components}>

<MDXTag name="p" components={components}><MDXTag name="img" components={components} parentName="p" props={{"src":"/work/impact/State_of_Impact_1.jpg","alt":"Reaktor.com screens"}}></MDXTag></MDXTag>

<TextCol>
  Design and art direction for The state of Impact, an annual report in the form
  of a magazine. The magazine is both a collection of in-depth conversations and
  shorter showcases of different people in the nordic countries committed to
  making the world a better place through technology and impact investing.
</TextCol>
<MDXTag name="p" components={components}><MDXTag name="img" components={components} parentName="p" props={{"src":"/work/impact/State_of_Impact_2.jpg","alt":"Reaktor.com frontpage"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/impact/State_of_Impact_3.jpg","alt":"Reaktor.com frontpage"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/impact/State_of_Impact_4.jpg","alt":"Reaktor.com frontpage"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/impact/State_of_Impact_5.jpg","alt":"Reaktor.com frontpage"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/impact/State_of_Impact_6.jpg","alt":"Reaktor.com frontpage"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/impact/State_of_Impact_7.jpg","alt":"Reaktor.com frontpage"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/impact/State_of_Impact_8.jpg","alt":"Reaktor.com frontpage"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/impact/State_of_Impact_9.jpg","alt":"Reaktor.com frontpage"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/impact/State_of_Impact_10.jpg","alt":"Reaktor.com frontpage"}}></MDXTag></MDXTag>
           </MDXTag>
  }
}

export const _frontmatter = {};

  